import React, { useState } from "react";
import { getSpacesForCutAllPages } from "utils";

import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { ConfirmModal } from "components/elements/ConfirmModal/ConfirmModal";
import { VoicingSettings } from "./components/VoicingSettings";
import { getDownloadVideUrl } from "./helpers";
import { DefaultModal } from "components/elements/DefaultModal";
import DownloadButton from "./components/DownloadButton";
import { FAST_API_URL } from "api";

export function Voicing() {
  const state = useAudioStateContext();
  const handles = useAudioHandlesContext();
  const voicingSpacesAllPages = state.voicingSpacesAllPages;
  const voicingSpacesDeleted = state.voicingSpacesDeleted;
  const [cutVideoUrl, setCutVideoUrl] = useState("");
  const [cutError, setCutError] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const [open, setOpen] = useState(false);

  const handleSubmit = async () => {
    const cutSnippets = getSpacesForCutAllPages(voicingSpacesAllPages, voicingSpacesDeleted);
    setOpen(false);
    const { data, error } = await handles.cutAudioWithoutPause({
      cut_snippets: cutSnippets[state.folder],
    });
    if (data) {
      const videoName = getDownloadVideUrl(data.video);
      const url = `${FAST_API_URL}/download_rus?file_name=${videoName}`;
      handles.addCatVideoFolderUrl({ url, folder: state.folder });
      setCutVideoUrl(url);
      setCutError("");
    }
    if (error) {
      setCutVideoUrl("");
      setCutError(error);
    }
    setOpenDownloadModal(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const renderDownloadBody = () => {
    if (cutVideoUrl) {
      return <DownloadButton url={cutVideoUrl} />;
    }
    return <div>{cutError}</div>;
  };

  return (
    <>
      <VoicingSettings setOpen={setOpen} setOpenDownload={setOpenDownloadModal} />
      <ConfirmModal
        title={"spaces removal"}
        text={`You remove spaces in  folder - ${state.folder}`}
        onOk={handleSubmit}
        onCancel={onClose}
        open={open}
      />
      <DefaultModal
        open={openDownloadModal}
        title={cutError ? "Cut video Error" : "Download cut video"}
        onCancel={() => setOpenDownloadModal(false)}
        body={renderDownloadBody()}
      />
    </>
  );
}
